import { LeadReportsStoreModels } from './leadReportsData.state';

export const LEAD_REPORTS_REQUEST = '[Reports] lead-reports-request';
export const LEAD_REPORTS_SUCSSES = '[Reports] lead-reports-success';
export const LEAD_REPORTS_FAILD = '[Reports] lead-reports-faild';

// Actions for Lead Reports
export class LeadReportsRequestAction {
    readonly type = LEAD_REPORTS_REQUEST;
}

  export class LeadReportsSuccessAction {
    readonly type = LEAD_REPORTS_SUCSSES;

    constructor(public payload?: LeadReportsStoreModels){}
  }

  export class LeadReportsFaildAction {
    readonly type = LEAD_REPORTS_FAILD;

    constructor(public payload?: any){}
  }
